var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.907,
    height: 19.076,
    viewBox: "0 0 25.907 19.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106",
    transform: "translate(-986.363 -702.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M1027.329,702.6h-.08c-.231,1.68-.712,3.008-3.224,3.253v.091c2.512.245,2.994,1.574,3.224,3.254h.08c.23-1.68.712-3.008,3.224-3.254v-.091C1028.041,705.6,1027.56,704.276,1027.329,702.6Z",
    transform: "translate(-19.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M1013.655,703.384h-.05c-.143,1.044-.443,1.87-2,2.022v.056c1.561.152,1.861.978,2,2.022h.05c.143-1.044.442-1.87,2-2.022v-.056C1014.1,705.254,1013.8,704.428,1013.655,703.384Z",
    transform: "translate(-12.954 -0.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M1013.494,719.1c-.667-1.138-2.939-4.866-4.36-5.4-.2-.086-.844-.27-7.7-1.275l-.253-.037a8.877,8.877,0,0,1-2.011-1.468l-.757-.646-.424.16c-1.566.59-3.731,3.2-4.767,4.866l-.31.5.4.432a4.928,4.928,0,0,1,1.062,2,6.575,6.575,0,0,0,2.346,3.5,6.32,6.32,0,0,0,4.028,1.133,20.368,20.368,0,0,0,5.647-.969,4.123,4.123,0,0,0,2.264-1.466,5.616,5.616,0,0,0,1.369.141,16.814,16.814,0,0,0,2.963-.326l1.051-.219Zm-3.471-.072a4.084,4.084,0,0,1-.965-.091,3.027,3.027,0,0,0-1.113-1.219,3.909,3.909,0,0,0-.524-.271l-.033-.034v.017a6.5,6.5,0,0,0-3.919-.008l-.509.1a.617.617,0,1,0,.238,1.211c.174-.035.348-.071.523-.108,1.292-.27,2.512-.525,3.571.135.046.029.084.064.127.1l.011.51c.007.334-.614.768-1.511,1.055a19.1,19.1,0,0,1-5.177.9,4.879,4.879,0,0,1-3.062-.794,5.071,5.071,0,0,1-1.85-2.787,6.977,6.977,0,0,0-1-2.085,14.592,14.592,0,0,1,3.318-3.577l.015.012a8.626,8.626,0,0,0,2.6,1.786s.164.035.448.077c6.11.895,7.185,1.126,7.328,1.171l.068.026c.462.163,1.738,1.794,2.973,3.762A12.379,12.379,0,0,1,1010.023,719.026Z",
    transform: "translate(-3.36 -3.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M1016.357,729.76c-1.466-.818-2.547-.44-3.438-.629a5.17,5.17,0,0,0-2.7.22,14.189,14.189,0,0,1-1.43.9c-.385.187-4.935,1.807-5.966,1.436a19.982,19.982,0,0,0-4.361-.926,3.574,3.574,0,0,0-2.933.653c-.865,1.533,2.113,4.511,4.431,3.693s4.363-1.193,5.863-.545,4.6.75,5.283-.171a4.479,4.479,0,0,1,3.221-1.874C1016.026,732.248,1017.823,730.578,1016.357,729.76Z",
    transform: "translate(-4.628 -13.578)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 9.215,
    height: 5.289,
    transform: "translate(986.363 709.948) rotate(-46.699)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.3488d99ce58fa13ca644f7c2d47f8f5d.svg";
export { ForwardRef as ReactComponent };